export default {
    namespaced: true,
    state: {
		title: '',
		params: {
			mode: 'KindBrendModel',
			datebegin: null,
			dateend: null,
			category: null,
			brand: null,
			model: null,
			region: null,
			city: null,
		},
		items: [],
    },
}